module.exports = __webpack_public_path__ + "static/media/qrcode.dba05265.png";